export interface DownloadLinksComponentOptions {
  /** Ссылка на скачивание приложения для Android платформы */
  androidDownloadLink?: string;

  /** Ссылка на скачивание приложения для iOS платформы */
  iosDownloadLink?: string;
}
